import { useState, useEffect, useCallback } from 'react'

const HEADER_HEIGHT = 88

export function useHeaderScroll() {
  const [showNav, setShowNav] = useState(true)
  const [scrollY, setScrollY] = useState(0)

  const scrollHandler = useCallback(() => {
    if (window.innerHeight + window.scrollY === window.document.body.scrollHeight) {
      setShowNav(false)
    } else if (scrollY < window.scrollY && window.scrollY > HEADER_HEIGHT) {
      setShowNav(false)
    } else {
      setShowNav(true)
    }
    setScrollY(window.scrollY)
  }, [scrollY])

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler)

    return () => {
      window.removeEventListener('scroll', scrollHandler)
    }
  }, [scrollHandler])

  return { showNav, scrollY }
}
